import useMediaQuery from './useMediaQuery';

export default function useViewport() {
  const isMobile = useMediaQuery('screen and (min-width: 1px) and (max-width: 757px)');
  const isTablet = useMediaQuery('screen and (min-width: 758px) and (max-width: 1279px)');
  const isDesktop = useMediaQuery('screen and (min-width: 1280px)');

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
}
